import Ajax from "Utils/ajax";
export const getAllStaff = (data) => Ajax.post('hr/getAllStaff',data);
export const getAllActiveDeactiveStaff = (data) => Ajax.post('hr/getAllActiveDeactiveStaff',data);
export const documentCategory = (data) => Ajax.post('hr/documentCategory',data);
export const getStaffDocumentList = (data) => Ajax.post('setting/getStaffDocumentList',data);
export const deleteDocument = (data) => Ajax.post('hr/deleteDocument',data);
export const getAllDocumentType = (data) => Ajax.post('hr/getAllDocumentType',data);
export const addUpdateStaffDocument = (data) => Ajax.post('hr/addUpdateStaffDocument',data);
export const getDocumentClass = (data) => Ajax.post('setting/getDocumentClass',data); 